import { render } from "./NotFound.vue?vue&type=template&id=e778134a"
const script = {}

import exportComponent from "C:\\Users\\Light\\Documents\\Projects\\PHP-Laravel\\TatSingWeb\\ts-group\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__